export enum EmploymentIndustry {
  'ACCOMMODATION_FOOD_SERVICES' = 'accommodationFoodServices',
  'ADMINISTRATIVE_SUPPORT_SERVICES' = 'administrativeSupportServices',
  'AGRICULTURE_FORESTRY_FISHING' = 'agricultureForestryFishing',
  'ARTS_RECREATION_SERVICES' = 'artsRecreationServices',
  'CONSTRUCTION' = 'construction',
  'EDUCATION_TRAINING' = 'educationTraining',
  'ELECTRICITY_GAS_WATER_WASTE_SERVICES' = 'electricityGasWaterWasteServices',
  'FINANCIAL_INSURANCE_SERVICES' = 'financialInsuranceServices',
  'HEALTH_CARE_SOCIAL_ASSISTANCE' = 'healthCareSocialAssistance',
  'INFORMATION_MEDIA_TELECOMMUNICATIONS' = 'informationMediaTelecommunications',
  'MANUFACTURING' = 'manufacturing',
  'MINING' = 'mining',
  'OTHER' = 'other',
  'PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES' = 'professionalScientificTechnicalServices',
  'PUBLIC_ADMINISTRATION_SAFETY' = 'publicAdministrationSafety',
  'RENTAL_HIRING_REAL_ESTATE_SERVICES' = 'rentalHiringRealEstateServices',
  'RETAIL_TRADE' = 'retailTrade',
  'TRANSPORT_POSTAL_WAREHOUSING' = 'transportPostalWarehousing',
  'WHOLESALE_TRADE' = 'wholesaleTrade',
}
